















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class DisclaimerAccordion extends Vue {
  @Prop({ required: true }) title!: string;
  protected readonly disclaimerIcon = require("@/assets/images/disclaimer-icon.svg");
  protected readonly disclaimerChevron = require("@/assets/images/disclaimer-chevron.svg");
}
